import { Component, OnChanges, Input, Output, EventEmitter } from "@angular/core";

import { JqueryExtensionsService } from "../services/jquery.service";
import { StringExtensions } from "../utilities/string.extensions";
import { IDropdownItem } from "./dropdown.component";

export interface IDropdownMultiselect {
	selected?: Array<number>;
	buttonText?: string; /* initial text to be displayed on the button */
	staticButtonText?: boolean; /* keeps the button text the original value after selecting */
	staticSelection?: boolean; /* clears the selection after an item is selected and emitted */
	disabled?: boolean;
}

export interface IDropdownHeader {
  headerId?: number;
  text?: string;
}

@Component({
  preserveWhitespaces: false, 
	selector: "dropdown-multiselect",
	template: `
	<select
		[id]="id"
		[attr.data-size]="rows"
		[attr.data-live-search]="isLiveSearch"
		[title]="model.buttonText === '' ? ' ' : model.buttonText !== undefined ? model.buttonText : ''"
		[attr.data-selected-text-format]="model.staticButtonText ? 'static' : ''"
		[disabled]="!!disabled"
		[attr.multiple]="'true'"
		[attr.data-actions-box]="dataActionsBox"
		[(ngModel)]="model.selected"
		class="form-control selectpicker">

    <ng-container *ngIf="headers.length<1">
			<option *ngIf="model.buttonText" data-hidden="true">{{model.buttonText}}</option>
			<option
        style="white-space:normal;"
				*ngFor="let item of dropdownItems"
				[value]="item.value"
				[attr.data-divider]="item.isSeparator"
				[disabled]="!!item.disabled">

				<span *ngIf="item.iconClasses?.length" class="item.iconClasses">
					<span class="{{item.iconClasses}}"></span>
					&nbsp;
				</span>
				<img *ngIf="item.flag?.length" class="flag-xs" src="assets/img/flags/{{item.flag}}.png" />
				{{item.text}}
			</option>
		</ng-container>

    <ng-container *ngIf="headers.length>0">
				<optgroup *ngFor="let header of headers" label="{{header.text}}">
					<ng-container *ngFor="let item of dropdownItems">
						<option *ngIf="header.headerId==item.headerId"
							value="{{item.value}}_{{item.headerId}}"
							[attr.data-divider]="item.isSeparator"
							[disabled]="!!item.disabled">

							<span *ngIf="item.iconClasses?.length" class="item.iconClasses">
								<span class="{{item.iconClasses}}"></span>
								&nbsp;
							</span>
							<img *ngIf="item.flag?.length" class="flag-xs" src="assets/img/flags/{{item.flag}}.png" />
							{{item.text}}
						</option>
					</ng-container>
				</optgroup>
			</ng-container>

	</select>
` })
export class DropdownMultiselectComponent implements OnChanges {
	@Input() id: string;
	@Input() rows: number;
	@Input() isLiveSearch: boolean;
  @Input() dataActionsBox = false;
  @Input() headers: IDropdownHeader[] = [];
	@Input() dropdownItems: IDropdownItem[];
	@Input() model: IDropdownMultiselect;
  @Input() disabled?: boolean;
  @Input() hasGlobalList?: boolean;
  @Input() globalList?: any;
  @Input() globalIncludedId?: string;

  @Output() dropdownChanged: EventEmitter<IDropdownItem[]> = new EventEmitter<IDropdownItem[]>();

  changesCounter: number = 0;

	constructor(private jqueryService: JqueryExtensionsService) { }

  ngOnChanges() {
		/* if value is invalid or not specified, create a default value to identify the item(s) clicked for emiting */
		this.fixItemValues();

		/* re-init */
		setTimeout(() => {
			/* default value is true if not specified */
			if (this.model.staticSelection === undefined) { this.model.staticSelection = true; }

			/* re-apply defaults */
			setTimeout(() => {
				this.refresh();
				// if (this.getSelectedValues(evt, this.id).filter(i => i <= 0).length > 0) {
					// this.deselectAll();
				// }
			});
    });

    if (this.hasGlobalList && this.changesCounter > 0) {
      if (this.globalList) {
        if (this.globalList.items.length > 0) {
          const currentList = $("#" + this.id).val() ? $("#" + this.id).val().map(i => Number(i)) : []
          let symDifference = currentList.filter(x => !this.globalList.items.includes(x))
            .concat(this.globalList.items.filter(x => !currentList.includes(x)));
          if (symDifference.length < 1) {
            return
          }
          else {
            if (this.id.includes(this.globalIncludedId)) {
              $("#" + this.id).selectpicker('val', this.globalList.items);
              $("#" + this.id).trigger("changed.bs.select", [this.globalList.items, true])
              this.refresh()
            }
          }
        }
        else {
          if (this.id.includes(this.globalIncludedId)) {
            const currentList = $("#" + this.id).val() ? $("#" + this.id).val().map(i => Number(i)) : [];
            let symDifference = currentList.filter(x => !this.globalList.items.includes(x))
              .concat(this.globalList.items.filter(x => !currentList.includes(x)));
            if (symDifference.length < 1) {
              return
            }
            else {
              if (this.id.includes(this.globalIncludedId)) {
                $("#" + this.id).selectpicker('val', this.globalList.items);
                $("#" + this.id).trigger("changed.bs.select", [currentList, false])
                this.refresh()
              }
            }
          }
        }
      }
    }
    if (this.hasGlobalList && this.changesCounter < 1) {
      // If changes counter is lower than 10 it means it is at the first render and we can take the global list as a the initialization variable
      if (this.globalList) {
        if (this.globalList.items.length > 0) {
          setTimeout(() => {
            if (this.id.includes(this.globalIncludedId)) {
              $("#" + this.id).selectpicker('val', this.globalList.items);
              $("#" + this.id).trigger("changed.bs.select", [this.globalList.items, true])
              this.refresh()
            }
          }, 10)
        }
      }
    }
    this.changesCounter += 1;
	}

  ngAfterViewInit() {
    /* use an internal id to prevent colisions */
    if (!this.id) { this.id = "dropdown-" + StringExtensions.generateUUID(); }

    this.refresh();

    let _this = this;
    $("#" + this.id).on("changed.bs.select", function (e, clickedIndex, isSelected) {
      let selected = _this.getSelectedValues(e, _this.id);
      let clickedOption = _this.dropdownItems[clickedIndex];
      if (isSelected && ((clickedOption && clickedOption.isExclusive) ||
        (selected && selected.length === 2 && _this.dropdownItems.find(x => x.value === selected[0]).isExclusive))
      ) {
        _this.jqueryService.setMultipleSelection(_this.id, [clickedOption.value + "_" + clickedOption.headerId]);
      }
      setTimeout(() => _this.onSelect(e));
    });
  }

	private refresh() { this.jqueryService.selectpicker("#" + this.id, "refresh"); }

	private deselectAll() { this.jqueryService.selectpicker("#" + this.id, "deselectAll"); }

	private fixItemValues() {
		if (!this.dropdownItems || this.dropdownItems.length === 0) { return; }

		let internalValue = 0;

		this.dropdownItems
			.forEach(i => internalValue = Math.max(0, isNaN(+(<number>i.value)) ? 0 : +(<number>i.value)));

		this.dropdownItems
			.filter(i => isNaN(+(<number>i.value)))
			.forEach(item => {
				internalValue += 1;
				item.value = internalValue;
			});
	}

	private getSelectedValues(event: any, id: string): Array<number> {
		return this.jqueryService.getMultipleSelection(event, id);
	}

  onSelect(event: any) {
    let selected = this.getSelectedValues(event, this.id);
    if (selected.length === 0) { this.dropdownChanged.emit([]); }

    let items = this.dropdownItems.filter(i => selected.indexOf(<number>i.value) >= 0);
    if (!items || items.length === 0) { return; }

    this.dropdownChanged.emit(items);
    if (!this.model.staticSelection) { setTimeout(() => this.deselectAll()); }
	}
}
